module.exports = __webpack_public_path__ + "static/media/talkTribeExample.13297490.png";